module.exports = __webpack_public_path__ + "media/application/images/2018/twitter-red-468ba23320c01535e70e8ff67500aa3b.svg";